(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileTicketOrdersController', ProfileTicketOrdersController);

    ProfileTicketOrdersController.$inject = ['$scope', '$window', '$rootScope', '$state', '$stateParams', '$http', '$translate', '$uibModal', 'entity', 'TicketPayment'];

    function ProfileTicketOrdersController($scope, $window, $rootScope, $state, $stateParams, $http, $translate, $uibModal, entity, TicketPayment) {
        var vm = this;

        vm.profile = entity;
        vm.itemsPerPage = 10;
        vm.page = 1;
        vm.maxPage = 1;
        vm.totalItems = 0;

        vm.ticketPayments = [];
        vm.loading = false;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.openTicketDetails = openTicketDetails;

        init();

        function init() {
            loadPage(1);
        }

        function buildParams(page) {
            console.log(vm.profile.customerPhone)
            var params = {
                valueInt1: page,
                size: vm.itemsPerPage,
                field: vm.profile.customerPhone
            };

            Object.keys(params).forEach(function (k) {
                if (params[k] === null || params[k] === undefined || params[k] === '') {
                    delete params[k];
                }
            });

            return params;
        }

        function loadPage(page) {
            if (page < 1) page = 1;
            if (vm.maxPage && page > vm.maxPage) page = vm.maxPage;

            vm.loading = true;

            loadAll(page);
        }

        function loadAll (page) {
            TicketPayment.queryFromMySafar(buildParams(page), onSuccess, onError);
            function onSuccess(data) {

                vm.ticketPayments = data.result || [];
                vm.page = data.page || page;

                vm.totalItems = data.count || 0;
                vm.maxPage = data.max_page || Math.max(1, Math.ceil(vm.totalItems / vm.itemsPerPage));
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadPage(vm.page);
        }

        function openTicketDetails(ticket) {
            $uibModal.open({
                templateUrl: 'app/entities/ticket-payment/ticket-order-detail-dialog.html',
                controller: 'TicketOrderDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'ticket-order-detail-dialog-xl',
                resolve: {
                    selectedTicket: ticket
                }
            });
        }

    }
})();
